import { ProjectLeadBriefingSection } from "./ProjectLeadBriefingSection";
import type { ProjectLeadSheetData } from "./useProjectLeadSheet";

export function ProjectLeadSheetSections({
  data,
  onDecideApproval,
}: {
  readonly data: ProjectLeadSheetData;
  readonly onDecideApproval: (
    approvalId: string,
    decision: "approved" | "denied",
    reason: string,
  ) => Promise<void>;
}) {
  return (
    <ProjectLeadBriefingSection briefing={data.briefing} onDecideApproval={onDecideApproval} />
  );
}
